import { render, staticRenderFns } from "./InvestmentClock.vue?vue&type=template&id=647cba10"
import script from "./InvestmentClock.vue?vue&type=script&lang=js"
export * from "./InvestmentClock.vue?vue&type=script&lang=js"
import style0 from "./InvestmentClock.vue?vue&type=style&index=0&id=647cba10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports